var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner"},[_vm._v(" Hola desde global Settings ")])
}
var staticRenderFns = []

export { render, staticRenderFns }